import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { BasicService } from 'src/app/shared/services/basic.service';
import { ExternalToolIntegrationModalService } from './external-tool-integration-modal.service';

@Component({
  selector: 'app-external-tool-integration-modal',
  templateUrl: './external-tool-integration-modal.component.html',
  styleUrls: ['./external-tool-integration-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ExternalToolIntegrationModalComponent implements OnDestroy, OnInit {
  @Input() iframeUrl: string;
  @Input() processedTaskId: number;

  @ViewChild('iframe', { static: true }) iframe: ElementRef<HTMLFrameElement>;

  trustedIframeUrl: SafeUrl;

  private iframeUrlOrigin: string;
  private iframeWindow: Window;

  private eventListener = (event: MessageEvent) => this.onMessageEvent(event);

  constructor(
    private sanitizer: DomSanitizer,
    private alcmeonContext: AlcmeonContextService,
    private basicService: BasicService,
    private externalToolIntegrationModalService: ExternalToolIntegrationModalService
  ) {}

  ngOnInit() {
    // start by registering the event listener, to be sure we don't miss any message
    this.basicService.window.addEventListener('message', this.eventListener, false);

    // Then set the iframe URL (it comes from the DB, let's trust it)
    this.trustedIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframeUrl);
    this.iframeUrlOrigin = new URL(this.iframeUrl).origin;
    this.iframeWindow = this.iframe.nativeElement.contentWindow;
  }

  ngOnDestroy() {
    this.basicService.window.removeEventListener('message', this.eventListener, false);
  }

  private onMessageEvent(event: MessageEvent) {
    if (event.origin === this.iframeUrlOrigin && event.source === this.iframeWindow) {
      this.handleMessageFromIframe(event.data);
    }
  }

  private handleMessageFromIframe(message) {
    const { type }: { type: string } = message;
    switch (type) {
      case 'getContext':
        this.externalToolIntegrationModalService.getTaskContext(this.processedTaskId).subscribe(context => {
          const reply = {
            type: 'context',
            context,
            agent: {
              id: this.alcmeonContext.self.id,
              name: this.alcmeonContext.self.realname,
              email: this.alcmeonContext.self.email,
            },
          };
          this.iframeWindow.postMessage(reply, this.iframeUrlOrigin);
        });
        break;
      case 'closeModal':
        this.basicService.dismissModal();
        break;
      default:
        console.warn(`ExternalToolIntegrationModalComponent - unknown message type ${type}`);
        break;
    }
  }
}
